import {TopSalesBaseElement} from "../models/top-sales-base-element";
import {SalesWrapper} from "../../../../utils/sales/sales-wrapper";
import {LinkedDtoRepository} from "../../../../../common/repositories/linked-dto-repository";
import {SalesDto} from "../../../../models/sales/sales-dto";

export class TopGridProcessor {
  static processLocationDataForTopSalesRanking(salesWrapper: SalesWrapper,
                                               linkedDtoRepository: LinkedDtoRepository<any>,
                                               revenueCalculationMethodFn: (salesDto: SalesDto) => number,
                                               rowKeyFn: (salesDto: SalesDto) => string = (salesDto) => salesDto.compositionId): {
    [id: string]: TopSalesBaseElement[]
  } {
    return this.processDataForTopSalesRanking(salesWrapper, linkedDtoRepository, "locationId", revenueCalculationMethodFn, rowKeyFn);
  }

  /**
   * Aggregates the ranking: an outer bucket per `key` (a location) and, inside it, one entry per composition-row
   * key.
   *
   * @param rowKeyFn what a ranking ENTRY is (#534) — `compositionId` (combined) or `compositionVariantKey`
   *                 ("Kombinationen einzeln", one entry per swap combination). The resulting
   *                 `TopSalesBaseElement.id` IS that key, so the caller must resolve names through the matching
   *                 `LinkedDtoRepository` mapping — see `TopSalesStore.mapCompositionIdToName`.
   */
  static processDataForTopSalesRanking(salesWrapper: SalesWrapper,
                                       linkedDtoRepository: LinkedDtoRepository<any>,
                                       key: keyof SalesDto,
                                       revenueCalculationMethodFn: (salesDto: SalesDto) => number,
                                       rowKeyFn: (salesDto: SalesDto) => string = (salesDto) => salesDto.compositionId): {
    [id: string]: TopSalesBaseElement[]
  } {
    let topSales: { [id: string]: TopSalesBaseElement[] } = {};
    for (let val of linkedDtoRepository.getKeyList(key)) {
      topSales[val.id] = [];
    }

    let cache: { [id: string]: { [id: string]: SalesDto[] } } = {};

    for (let baseOrderElement of salesWrapper.getBaseOrderElements()) {
      let key_ = baseOrderElement[key] as string;
      let rowKey = rowKeyFn(baseOrderElement);
      if (cache[key_] === undefined) {
        cache[key_] = {};
      }
      if (cache[key_][rowKey] === undefined) {
        cache[key_][rowKey] = [];
      }

      cache[key_]![rowKey]!.push(baseOrderElement);
    }

    for (let key_ in cache) {
      for (let rowKey in cache[key_]) {
        let baseOrderElements = cache[key_][rowKey];
        let totalRevenue = baseOrderElements.reduce((acc, baseOrderElement) => {
          return acc + revenueCalculationMethodFn(baseOrderElement)
        }, 0);
        let totalQuantity = baseOrderElements.reduce((acc, baseOrderElement) => {
          return acc + baseOrderElement.quantity
        }, 0);

        topSales[key_].push(new TopSalesBaseElement(rowKey, totalRevenue, totalQuantity));
      }
    }


    return topSales;
  }
}
